var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "21",
        height: "21",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          d:
            "M5.3333 1.6001L2.1333 4.8001L5.3333 8.0001V5.86676H9.06663C10.552 5.86676 11.7333 7.04803 11.7333 8.53343C11.7333 10.0188 10.552 11.2001 9.06663 11.2001H7.46663C7.32529 11.1981 7.18495 11.2242 7.05379 11.2769C6.92262 11.3296 6.80324 11.4079 6.70258 11.5071C6.60192 11.6064 6.52199 11.7246 6.46743 11.855C6.41287 11.9855 6.38478 12.1254 6.38478 12.2668C6.38478 12.4081 6.41287 12.5481 6.46743 12.6785C6.52199 12.8089 6.60192 12.9272 6.70258 13.0264C6.80324 13.1256 6.92262 13.2039 7.05379 13.2566C7.18495 13.3093 7.32529 13.3354 7.46663 13.3334H9.06663C11.5597 13.3334 13.5632 11.3825 13.7833 8.94385C13.8379 8.81389 13.8662 8.6744 13.8666 8.53343C13.8666 5.8951 11.705 3.73343 9.06663 3.73343H5.3333V1.6001Z",
          fill: "CurrentColor"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }